import { useSelector } from "react-redux";
import type { RootState } from "../store/store";

/**
 * Lê o usuário logado direto do authSlice (já populado no login e
 * espelhado em localStorage("_user") pelo próprio slice).
 */
export function useUsuarioLogado() {
  return useSelector((state: RootState) => state.auth.user);
}

/**
 * CRITÉRIO DE "NÍVEL 2" — o Usuario salvo no authSlice carrega `nivel` como a
 * bitmask de 10 dígitos (ex: "1111111111"), não o id de T15_NIVEL_USUARIO.
 * Assumi que "nível 2" é a posição de índice 2 dessa string estar habilitada.
 * Ajuste o índice abaixo se a posição correta for outra.
 */
const POSICAO_NIVEL_CADASTRO = 0;

export function useTemAcessoCadastro(): boolean {
  const usuario = useUsuarioLogado();
  if (!usuario?.nivel) return false;
  return usuario.nivel.charAt(POSICAO_NIVEL_CADASTRO) === "1";
}
